import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import RequestDetailsState from '../state/RequestDetailsState';
import {Display} from 'shared/components';
import _ from 'lodash';
import TimeOffRequestDetails from './TimeOffRequestDetails';
import PendingRequestDetailsWithState from '../../pending_requests/components/PendingRequestDetailsWithState';

const RequestDetails = observer(({uiState}) => {
  const {request, backButtonDetails, error} = uiState;
  const {backTitle} = backButtonDetails;

  if (error) {
    return (
      <div className='Container pt4'>
        <div className='h2 center'>
          {error}
        </div>
      </div>
    );
  }

  return (
    <div>
      <Display
        title={_.get(request, 'employee.name')}
        backTitle={backTitle}
        onBackClick={() => uiState.goBack()}
      />
      {request.actionable ?
        <PendingRequestDetailsWithState request={request} goBack={(alert) => uiState.goBack(alert)} /> :
        <TimeOffRequestDetails request={request} />
      }
    </div>
  );
});

export default withState(RequestDetails, RequestDetailsState);
